import http from '../../../Utils/http';

const PartnerIntegrations = {
  name: 'partnerIntegrations',
  state: {
    catalog: [],
    catalogLoading: false,
    actionLoading: false,
    actionCode: null,
  },
  reducers: {
    catalogRequested(state) {
      return { ...state, catalogLoading: true };
    },
    catalogReceived(state, payload) {
      return {
        ...state,
        catalogLoading: false,
        catalog: Array.isArray(payload) ? payload : [],
      };
    },
    catalogFailed(state) {
      return { ...state, catalogLoading: false };
    },
    actionStarted(state, code) {
      return { ...state, actionLoading: true, actionCode: code };
    },
    actionFinished(state) {
      return { ...state, actionLoading: false, actionCode: null };
    },
    clearCatalog(state) {
      return { ...state, catalog: [], catalogLoading: false };
    },
  },
  effects: (dispatch) => ({
    async fetchCatalog() {
      try {
        this.catalogRequested();
        const response = await http.get('savvy/partner-integrations');
        this.catalogReceived(response?.data?.data ?? response?.data ?? []);
      } catch {
        this.catalogFailed();
      }
    },
    async registerPartner({ orgId, partnerCode }) {
      try {
        this.actionStarted(partnerCode);
        const response = await http.post(
          `savvy/organization/${orgId}/partner-registrations`,
          { partner_code: partnerCode }
        );
        this.actionFinished();
        dispatch({
          type: 'helper/show',
          payload: {
            type: 'success',
            message: response?.data?.message || 'Partner activated for this organization',
            open: true,
          },
        });
      } catch (err) {
        this.actionFinished();
        const message =
          err?.response?.data?.message ||
          err?.response?.data?.error ||
          'Failed to activate partner';
        dispatch({
          type: 'helper/show',
          payload: { type: 'error', message, open: true },
        });
        throw err;
      }
    },
    async deactivatePartner({ orgId, partnerCode }) {
      try {
        this.actionStarted(partnerCode);
        const response = await http.put(
          `savvy/organization/${orgId}/partner-registrations/${partnerCode}/deactivate`
        );
        this.actionFinished();
        dispatch({
          type: 'helper/show',
          payload: {
            type: 'success',
            message: response?.data?.message || 'Partner deactivated for this organization',
            open: true,
          },
        });
      } catch (err) {
        this.actionFinished();
        const message =
          err?.response?.data?.message ||
          err?.response?.data?.error ||
          'Failed to deactivate partner';
        dispatch({
          type: 'helper/show',
          payload: { type: 'error', message, open: true },
        });
        throw err;
      }
    },
    clearPartnerCatalog() {
      this.clearCatalog();
    },
  }),
};

export default PartnerIntegrations;
